/* globals jQuery */
import 'fitvids.1.1.0'

import './slideshows.js'
import responsiveNav from './responsive-nav.js'
import accordion from './jquery.accordion.js'

(($) => {

    //$.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    const html = document.querySelector('html');
    html.classList.remove('no-js')
    html.classList.add('js');

    // Make nav menu nice & responsive
    const mainNav = document.querySelector('nav.main-nav');
    if( mainNav ){
        responsiveNav(mainNav,{
            navType: 'offCanvas',
            closeOnOutsideClick: true
        });
    }

    // Responsive Videos
    $('.rtecontent, .video').fitVids();

    // Accordions
    $('dl.accordion').accordion();

    //filter on change
    $('#categoryFilter').on('change',function(){
		var catLink = $(this).val();
		window.location = catLink;
	});

    // Pause/play video on .js-pause-video button click
    $('.js-pause-video').on('click', function() {
        const video = $(this).siblings('video')[0];
        if (video) {
            if (video.paused) {
                video.play();
                $(this).attr('aria-pressed', 'true');
                $(this).attr('aria-label', 'Pause video');
            } else {
                video.pause();
                $(this).attr('aria-pressed', 'false');
                $(this).attr('aria-label', 'Unpause video');
            }
            $(this).toggleClass('is-paused');
        }
    });

})(jQuery)
